export const ROOT_GLOBAL = {
  HOME_PAGE: "/",
  HOME_PAGE_US: "/us",
  LOGIN: "/?page=login",
  SIGN_UP: "/?page=signup",
  EXTENSION: "/extension",
  TRACKING: "/track",
  AVAILABLE_STORES: "/available-stores",
  CHECKOUT: "/checkout",
  ORDER: "/order/",
  ORDER_TRACKING: "/order-tracking",
  ORDER_HISTORY: "/order-history",
  ORDER_DETAIL: "/order-detail/",
  FAQS: '/faqs',
  CAREER: "/career",
  JOB_LIST: "/job-list",
  REFERRAL_PAGE: "/referral-page",
  SUMMARY: "/summary",
  THANKYOU: "/thankyou",
  METABASE: "/collaborator",
  CTV: "/tro-thanh-doi-tac",
  CTV_REGISTER: "/dang-ky-tro-thanh-doi-tac",
  LANDING_PAGE: "/lp/",
  PAYMENT: "/payment-processing",
  ADDRESS_BOOK: "/address-book",
  CONTACT: "/contact",
  COLLABORATOR_DASHBOARD: "/collaborator",
  COLLABORATOR_PRODUCT: "/collaborator-products",
  COLLABORATOR_PROFILE: "/collaborator-profile",
  WELCOME: "/welcome",
  TRACKING_SHORT_LINK: "/tracking/shortlink",
  TRACKING_INSTALL_LINK: "/tracking/install",
  TRACKING_WELCOME: "/tracking/welcome",
  BLOGS: "/blogs",
  SEARCH: "/explore",
  PRODUCT_DETAIL: "/",
  TERM_OF_USE: "/termofuse",
  HOW_IT_WORKS: "/#how-it-works",
  ERROR_PAGE: "/error-page",
  SHORT_LINK: "/short-link",
  SHORT: "/s/",
  SHORT_LINK_PRODUCT: "/s/p/",
  M_HOME_PAGE: "/m-home",
  M_MENU: "/m-menu",
  NOTIFICATIONS: "/notifications",
  SITES: "sites",
  BECOME_OUR_MERCHANT: "/become-our-merchant",
  MERCHANT_MANAGEMENT: "/merchant-management",
  MERCHANT_DASHBOARD: "/merchant-dashboard",
}

export const REQUIRE_LOGIN_PATHS = [
  // ROOT_GLOBAL.USER_CLASSIFICATION,
  ROOT_GLOBAL.USER_DUTY_TAX_CALCULATION,
  ROOT_GLOBAL.USER_TRADE_ADVISORY,
  ROOT_GLOBAL.YOUR_PLAN,
  ROOT_GLOBAL.PROFILE_MANAGE
]

export const REQUIRE_UN_LOGIN_PATHS = [
  ROOT_GLOBAL.HOME_PAGE
]